import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';


import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch,clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';
import { startFormLoading } from '../../store/actions/loader';

class AssetDocuments extends Component {
  componentDidMount(){
    const { asset,clearSearch,onFetchFaqsNotesDocuments} = this.props;
    clearSearch()
    // onFetchFaqsNotesDocuments(asset.id);
  }

  onSave = async (document) => {
    this.props.onStartFormLoading();
    let image = null
    if(document && document.image && document.image.length > 0 && document.image[0].path){
      let path = document.image[0].path;
      let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
      image =  await upload(document.image[0], newFileName.replace(/ /g,''))
      document = document = {...document,image}
    }
    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.asset.id,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.id,
      isImportantDocument: document.isImportantDocument
    }
    this.props.onSaveFaqsNotesDocuments(data)

  }
  onDeleteFaqsNotesDocuments(document){
    document.Type = 'DOCUMENT';
    this.props.onDeleteFaqsNotesDocuments(document)
  }
  render() {
    const { asset, documents,setSearch } = this.props;
    return (
      <Documents
        breadcrumb={asset.name}
        documents={documents}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Manuals & Documents"}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  documents: selectDocuments(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssetDocuments);
